var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _NativeReanimated = _interopRequireDefault(require("./NativeReanimated"));
var _core = require("./core");
function jsListener(eventName, handler) {
    return function(evt) {
        handler(Object.assign({}, evt.nativeEvent, {
            eventName: eventName
        }));
    };
}
var WorkletEventHandler = exports.default = function() {
    function WorkletEventHandler(worklet) {
        var eventNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        (0, _classCallCheck2.default)(this, WorkletEventHandler);
        this.worklet = void 0;
        this.eventNames = void 0;
        this.reattachNeeded = void 0;
        this.listeners = void 0;
        this.viewTag = void 0;
        this.registrations = void 0;
        this.worklet = worklet;
        this.eventNames = eventNames;
        this.reattachNeeded = false;
        this.listeners = {};
        this.viewTag = undefined;
        this.registrations = [];
        if (!_NativeReanimated.default.native) {
            this.listeners = eventNames.reduce(function(acc, eventName) {
                acc[eventName] = jsListener(eventName, worklet);
                return acc;
            }, {});
        }
    }
    (0, _createClass2.default)(WorkletEventHandler, [
        {
            key: "updateWorklet",
            value: function updateWorklet(newWorklet) {
                this.worklet = newWorklet;
                this.reattachNeeded = true;
            }
        },
        {
            key: "registerForEvents",
            value: function registerForEvents(viewTag, fallbackEventName) {
                var _this = this;
                this.viewTag = viewTag;
                this.registrations = this.eventNames.map(function(eventName) {
                    return (0, _core.registerEventHandler)(_this.worklet, eventName, viewTag);
                });
                if (this.registrations.length === 0 && fallbackEventName) {
                    this.registrations.push((0, _core.registerEventHandler)(this.worklet, fallbackEventName, viewTag));
                }
            }
        },
        {
            key: "registerForEventByName",
            value: function registerForEventByName(eventName) {
                this.registrations.push((0, _core.registerEventHandler)(this.worklet, eventName));
            }
        },
        {
            key: "unregisterFromEvents",
            value: function unregisterFromEvents() {
                this.registrations.forEach(function(id) {
                    return (0, _core.unregisterEventHandler)(id);
                });
                this.registrations = [];
            }
        }
    ]);
    return WorkletEventHandler;
}();
